import React from 'react';
import { Alert } from '@innovationnorway/cl-react';

import useEventParticipants from 'src/hooks/use-event-participants';
import { useTranslation } from 'react-i18next';
import useEventTimeEntries from 'src/hooks/use-event-time-entries';
import DataTableV3 from 'src/components/DataTableV3';

import { DataTableV3Ids } from 'src/constants/dataTableIds';
import { useEventParticpantColumns } from 'src/features/events';

type EventParticipantsTableTypes = {
  eventId: string;
};

const EventParticipantsTable: React.FC<EventParticipantsTableTypes> = ({ eventId }) => {
  const columns = useEventParticpantColumns();

  const { eventParticipants } = useEventParticipants(eventId);

  const { timeEntries } = useEventTimeEntries(eventId);

  const { t: tEvents } = useTranslation('events');

  return (
    <>
      {eventParticipants ? (
        <DataTableV3
          id={DataTableV3Ids.ResourceBase.Events.Participants}
          data={timeEntries}
          columns={columns}
        />
      ) : (
        <Alert data-color="info">{tEvents('noParticipantsRegistered')}</Alert>
      )}
    </>
  );
};

export default EventParticipantsTable;
